import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/oncommit.png";
import avatarVideo from "../../assets/bg/evidencia-1-avatar.webm";
import avatarVideoMp4 from "../../assets/bg/evidencia-1-avatar.mp4";
import manuelVideo from "../../assets/bg/evidencia-1-manuel.webm"; 
import manuelVideoMp4 from "../../assets/bg/evidencia-1-manuel.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario5Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	
	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});
	
	const [canOpenDialog, setCanOpenDialog] = useState(false);

	const transcription = "A mí me da confianza que mi tratamiento esté basado en estudios, que no sea al azar. Yo lo que quiero es estar seguro de que lo que me dé ya está probado y que de verdad me ayude a vivir con calidad."

	const handleContinue = () => {
		navigate(ROUTES.SCENARIO5);
	};

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 0.8, "green");
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	useEffect(() => {
		const timer = setTimeout(() => setCanOpenDialog(true), 20000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "60%",
							}}
						/>
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted={!canPlayWithSound}
							onEnded={() => setCanOpenDialog(true)}
							onError={() => setCanOpenDialog(true)}
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-end align-items-end bg-evidencia-a h-100 px-5">
						<div className="recuadro recuadro-green txtTexto1 w-100">
							<p>Tras repasar toda la evolución de Manuel, es momento de adentrarse en la siguiente sala. Allí analizarás la evidencia disponible para fundamentar cada decisión clínica y avanzar en su cuidado.</p>
							<div className="d-flex justify-content-center">
								<div
								    className={`button-escuchar-paciente button-escuchar-paciente-green mt-4 mb-4 ${!canOpenDialog ? "is-disabled" : ""}`}
									aria-disabled={!canOpenDialog}
									onClick={canOpenDialog ? abrirModal : undefined}
									style={!canOpenDialog ? { pointerEvents: "none" } : undefined}
								>
									Escuchar al paciente
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario5Intro);
